export default function handleDomainDataMutationResult({
    mutationResult,
    currentDataDomainId,
    getBusinessAreaDataById,
    fetchBusinessAreaDomainData,
    showError,
    showSuccess,
    showWarning,
}) {
    if (mutationResult.inProgress || currentDataDomainId !== mutationResult.dataDomainId) {
        return;
    }

    if (mutationResult.success) {
        const action = mutationResult.operation === "delete" ? "deleted" : mutationResult.operation === "update" ? "updated" : "created";
        showSuccess(`Domain data record ${action} successfully.`);
        return;
    }

    if (mutationResult.outcomeUncertain) {
        getBusinessAreaDataById(mutationResult.dataDomainId);
        fetchBusinessAreaDomainData(mutationResult.dataDomainId, null);
        showWarning("The server may have completed this change. Review the refreshed records before trying again.");
    } else if (["DOMAIN_DATA_VERSION_CONFLICT", "DOMAIN_DATA_NOT_FOUND"].includes(mutationResult.code)) {
        fetchBusinessAreaDomainData(mutationResult.dataDomainId, null);
        showError(mutationResult.message || "The domain-data record has changed. Review the refreshed records and try again.");
    } else if (mutationResult.code === "DATA_DOMAIN_NOT_FOUND") {
        getBusinessAreaDataById(mutationResult.dataDomainId);
        showError(mutationResult.message || "The data domain no longer exists.");
    } else {
        showError(mutationResult.message || "The domain data record could not be saved.");
    }
}
